export const POSTHOG_KEY = import.meta.env.VITE_REACT_APP_PUBLIC_POSTHOG_KEY;
export const POSTHOG_HOST = import.meta.env.VITE_REACT_APP_PUBLIC_POSTHOG_HOST;
export const HUBSPOT_TRACKING_ID = import.meta.env.VITE_HUBSPOT_ID;
export const GX_API_URL = import.meta.env.VITE_GX_API_ENDPOINT;
export const GO_API_URL = import.meta.env.VITE_REACT_APP_API_ENDPOINT;
export const GX_DATA_URL = import.meta.env.VITE_GX_DATA_ENDPOINT;
export const GX_INTERNAL_URL = import.meta.env.VITE_GX_INTERNAL_ENDPOINT;
export const GX_GO_TOKEN = import.meta.env.VITE_GX_GO_TOKEN;
